import React from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';

import { AsYouType } from 'libphonenumber-js';
import moment from 'moment';
// import Moment from "react-moment";

import PropTypes from 'prop-types';

class Forms extends React.Component {
    /**
     * 기본 데이터 변경시
     * @param  e
     */
    onChange = e => {
        if (e.target.value.length > this.props.maxLengh) {
            // return;
            e.target.value = e.target.value.substr(0, this.props.maxLengh);
        }
        if (this.props.onChange !== undefined) {
            this.props.onChange(e);
        }
    };

    render() {
        return (
            // <div className="row_vot_txt">
            //     <span className="tit">{this.props.title} :</span>
            //     <div className={this.props.error ? "in_b red" : "in_b"}>
            //         <input type="text" placeholder={this.props.placeholder} value={this.props.value} onChange={this.onChange} />
            //         <span className="num">
            //             <b>{this.props.value.length}</b>/{this.props.maxLengh}
            //         </span>
            //     </div>
            // </div>
            <Form.Group>
                <Form.Label>{this.props.title}</Form.Label>
                <Form.Control
                    type={'text'}
                    value={this.props.value === null ? '' : this.props.value}
                    placeholder={this.props.placeholder}
                    onChange={this.onChange}
                    disabled={this.props.disabled}
                />
            </Form.Group>
        );
    }
}

export default Forms;
